import { useQuery } from '@tanstack/react-query'

import { DefaultApiGetDepositBankAccountRequest } from '@src/api/generated/user-api'
import { getDepositBankAccount } from '@src/api/repositories'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

export const useFetchDepositBankAccount = (
  params: DefaultApiGetDepositBankAccountRequest
) => {
  const { axiosInstance } = useAxios()

  return useQuery({
    enabled: !!params.organizationId,
    queryFn: () => getDepositBankAccount(axiosInstance, params),
    queryKey: [
      REACT_QUERY_CACHE_KEYS.GET_DEPOSIT_BANK_ACCOUNT,
      params.organizationId,
    ],
  })
}
